import { render, staticRenderFns } from "./facebook-logs-sv4.vue?vue&type=template&id=eb23f6ce&"
import script from "./facebook-logs-sv4.vue?vue&type=script&lang=js&"
export * from "./facebook-logs-sv4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports